(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["habiba-home-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('habiba-featured-products')) {
    customElements.define(
      'habiba-featured-products',
      class HabibaFeaturedProducts extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-habiba-featured-tab]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectTab(tab));
          });
        }

        selectTab(activeTab) {
          const activeGroup = activeTab.dataset.habibaFeaturedTab;

          this.tabs.forEach((tab) => {
            const isActive = tab === activeTab;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          this.panels.forEach((panel) => {
            const isActive = panel.id.endsWith(`-${activeGroup}`);
            panel.classList.toggle('is-active', isActive);
            panel.toggleAttribute('hidden', !isActive);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["habiba-home-review-carousel"] && !Shopify.designMode) return;
  try {
    
  class HabibaReviewCarousel {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-review-viewport]');
      this.prev = section.querySelector('[data-review-prev]');
      this.next = section.querySelector('[data-review-next]');

      if (!this.viewport) return;

      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));
    }

    scroll(direction) {
      const amount = Math.max(this.viewport.clientWidth * 0.78, 280);
      this.viewport.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }
  }

  document.querySelectorAll('[data-review-carousel]').forEach((section) => {
    new HabibaReviewCarousel(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["habiba-landing-review-carousel"] && !Shopify.designMode) return;
  try {
    
  class HabibaReviewCarousel {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-review-viewport]');
      this.prev = section.querySelector('[data-review-prev]');
      this.next = section.querySelector('[data-review-next]');

      if (!this.viewport) return;

      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));
    }

    scroll(direction) {
      const amount = Math.max(this.viewport.clientWidth * 0.78, 280);
      this.viewport.scrollBy({
        left: direction * amount,
        behavior: 'smooth'
      });
    }
  }

  document.querySelectorAll('[data-review-carousel]').forEach((section) => {
    new HabibaReviewCarousel(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
